import menu from './menu'

const header = [ ...menu ]

// 菜单 顶栏
export default [
  ...menu
]

export { header }
